module.exports = __webpack_public_path__ + "img/chevron-down-double.ff6a8324.svg";